// @flow
import type { SearchParams, SearchFilter, Sorting } from "types/Global";

export default function buildParams(
  projectedColumns: Array<string>,
  page: number,
  size: number,
  filter?: ?SearchFilter,
  sorting?: ?Array<Sorting>,
  functionalAttributes?: Array<string>
): SearchParams {
  const { q } = buildQueryParams(
    projectedColumns,
    filter,
    sorting,
    functionalAttributes
  );
  return { q, page, size };
}

export function getFilterString(filter) {
  let fil = "";
  if (filter && filter.filters && filter.filters.length > 0) {
    let delimiter = filter.filteringFunction;
    const filtersLength = filter.filters.length;
    fil = filter.filters.reduce((acc, f, idx) => {
      if (idx === filtersLength - 1) {
        delimiter = ";";
      }
      return (acc += `${f.columnName}#${f.value}${delimiter}`);
    }, "filter:");
  }
  return fil;
}
export function getSortString(sorting) {
  let sort = "";
  if (sorting && sorting.length > 0) {
    let delimiter = ",";
    const sortingLength = sorting.length;
    sort = sorting.reduce((acc, s, idx) => {
      if (idx === sortingLength - 1) {
        delimiter = ";";
      }
      return (acc += `${s.columnName} ${s.direction}${delimiter}`);
    }, "sort:");
  }
  return sort;
}

export function buildQueryParams(
  projectedColumns: Array<string>,
  filter?: ?SearchFilter,
  sorting?: ?Array<Sorting>,
  functionalAttributes?: Array<string>
): SearchParams {
  let delimiter = ",";
  const requiredColumns =
    functionalAttributes && Array.isArray(functionalAttributes)
      ? projectedColumns.concat(
          functionalAttributes.filter(
            (attr) => !projectedColumns.includes(attr)
          )
        )
      : projectedColumns;
  const projectedColumnsLength = requiredColumns.length;
  const proj = requiredColumns.reduce((acc, col, idx) => {
    if (idx === projectedColumnsLength - 1) {
      delimiter = ";";
    }
    return (acc += `${col}${delimiter}`);
  }, "proj:");
  let fil = getFilterString(filter);
  let sort = getSortString(sorting);

  return {
    q: `${proj}${fil}${sort}`,
  };
}

// Query builders for search (see CM5 search implementation)
// we don't want to expose any of these functions
export function paramsEqual(
  params1: ?SearchParams,
  params2: ?SearchParams
): boolean {
  return (
    queryParamsEqual(params1, params2) &&
    params1.page === params2.page &&
    params1.size === params2.size
  );
}

export function queryParamsEqual(
  params1: ?SearchParams,
  params2: ?SearchParams
): boolean {
  return params1 != null && params2 != null && params1.q === params2.q;
}
